<template>
  <div>
    <div class="feedback-wrap">
      <div class="head-topbar lite-page-top linebottom sticky">
        <div class="topbar-left" @click="goto('/my')"><i class="icon-arrow-left"></i></div>
        <div class="topbar-main"><h4>帮助反馈</h4></div>
      </div>
      <div>
        <div class="faq-content">
          <div>
            <div v-for="(item,index) in feedlinkList" :key="index" class="faq-title" @click="gotoView(item.id)">{{item.question}}</div>
          </div>
        </div>
      </div>
      <div class="fixed-wrap">
        <div class="bottom-wrap">
          <div class="bottom-btn btn-left" @click="goto('/jnt/center/feedback')">意见反馈</div>
          <div class="bottom-btn btn-right" @click="show = true">联系客服</div>
        </div>
        <div style="background: rgb(228, 128, 60);">
          <div class="adm-safe-area adm-safe-area-position-bottom"></div>
        </div>
      </div>
    </div>

    <van-action-sheet v-model="show" title="联系客服">
      <div class="helpcontent">0546-75889977</div>
    </van-action-sheet>
  </div>
</template>

<script>
export default {
  name: 'contact',
  data() {
    return {
      show: false,
      feedlinkList: []
    }
  },
  methods: {
    gotoView(id) {
      this.$router.push({ path: '/jnt/help/' + id })
    },
    goto(str) {
      this.$router.push({ path: str })
    },
    queryFeedlinkAll(){
      var that=this
      this.$queryAll('MsgFeedlink', {
          sort: {orderNum:1}
        }, ['id,question,answer,orderNum'], function(res) {
        that.feedlinkList = res.data
      })
    }
  },
  mounted(){
    this.queryFeedlinkAll()
  },
  created() {},
  watch: {},
}
</script>

<style>
.faq-content {
  padding: 0 1.363rem;
  box-sizing: border-box;
  padding-bottom: 1.363rem;
}

.faq-content .faq-title {
  padding-top: 1.363rem;
  font-size: 1.45rem;
  color: #333;
  line-height: 1.5;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
}

.faq-content .faq-name {
  font-size: 1.272rem;
  color: #333;
  box-sizing: border-box;
  margin-top: 1.363rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
}

.head-topbar.sticky {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
}
.head-topbar {
  display: flex;
  align-items: center;
  height: 3.8rem;
  background: #fff;
  position: fixed;
  width: 100%;
  z-index: 1;
}
.dashedlinebottom,
.dashedlinetop,
.linebottom,
.lineright,
.linetop {
  position: relative;
  -webkit-box-sizing: border-box;
  padding: 0;
}
.head-topbar .topbar-left {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 6.73333vw;
  position: absolute;
  left: 0.265rem;
  height: 100%;
  z-index: 10;
}

.head-topbar .topbar-left .icon-arrow-left {
  background: url(../../../assets/jnt/left1.png) no-repeat;
  background-size: 100%;
  display: inline-block;
  height: 1.363rem;
  width: 0.818rem;
}
.head-topbar .topbar-main,
.head-topbar .topbar-right {
  display: flex;
  justify-content: center;
  align-items: center;
}
.head-topbar .topbar-main {
  flex: 1;
  color: #333;
  font-size: 1.454rem;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: 100%;
  font-weight: 400;
}
.head-topbar .topbar-right {
  padding-right: 1rem;
  position: absolute;
  right: 0.265rem;
  font-size: 1.272rem;
}
.head-topbar .topbar-main,
.head-topbar .topbar-right {
  display: flex;
  justify-content: center;
  align-items: center;
}
.helpcontent {
  color: rgb(177, 109, 78);
  position: relative;
  padding: 0;
  text-align: center;
  font-size: 1.3rem;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 4.2rem;
  display: flex;
}
.feedback-wrap .fixed-wrap {
  width: 100%;
  position: fixed;
  left: 0;
  bottom: 0;
}
.feedback-wrap .bottom-wrap {
  width: 100%;
  height: 4rem;
  line-height: 4rem;
  padding: 0 1.363rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  background-color: #fff;
}
.feedback-wrap .bottom-wrap .bottom-btn.btn-left {
  position: relative;
}
.feedback-wrap .bottom-wrap .bottom-btn {
  width: 50%;
  font-size: 1.45rem;
  color: #333;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.feedback-wrap .bottom-wrap .bottom-btn.btn-left:before {
  content: '';
  width: 1.82rem;
  height: 1.82rem;
  background: url(../../../assets/jnt/edit3.png) no-repeat;
  background-size: 100% 100%;
  display: inline-block;
  margin-right: 7px;
}
.feedback-wrap .bottom-wrap .bottom-btn.btn-left:after {
  content: '';
  width: 1px;
  height: 20px;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  background-color: #f2f2f2;
}
.feedback-wrap .bottom-wrap .bottom-btn {
  width: 50%;
  font-size: 1.45rem;
  color: #333;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.feedback-wrap .bottom-wrap .bottom-btn.btn-right:before {
  content: '';
  width: 1.82rem;
  height: 1.82rem;
  background: url(../../../assets/jnt/kf.png) no-repeat;
  background-size: 100% 100%;
  display: inline-block;
  margin-right: 7px;
}
</style>
